var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderTypeStaging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F3EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9857_7141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0419 18.5L10 26H10.9167L12.4 18.5H11.0419Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9571 18.5L21.9996 26H21.0824L19.5996 18.5H20.9571Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6421 15.5419V7.73357C20.6421 6.83719 19.8175 6.10352 18.8104 6.10352H13.156C12.1478 6.10352 11.3242 6.83719 11.3242 7.73357V15.5419H20.6421Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5215 17.0938C11.1724 17.0938 10.9 17.3854 10.9 17.7188C10.9 18.0521 11.1724 18.3438 11.5215 18.3438H20.4785C20.8284 18.3438 21.1 18.0524 21.1 17.7188C21.1 17.3854 20.8276 17.0938 20.4785 17.0938H11.5215ZM10 17.7188C10 16.8498 10.6926 16.1562 11.5215 16.1562H20.4785C21.3074 16.1562 22 16.8498 22 17.7188C22 18.5874 21.3087 19.2812 20.4785 19.2812H11.5215C10.6926 19.2812 10 18.5877 10 17.7188Z",
    fill: "#12181E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9857_7141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 20,
    fill: "white",
    transform: "translate(10 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTypeStaging);
export default __webpack_public_path__ + "static/media/order_type_staging.ee25a27f267176919b03d7023742d88d.svg";
export { ForwardRef as ReactComponent };